import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AppRoutingModule } from './app-routing.module';

// Services & Guards
import { GlobalService } from './services/global.service';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './auth/auth.guard';
import { UserGuard } from './auth/user.guard';
import { CommonModule } from '@angular/common';

// Non-standalone components
import { HomeComponent } from './pages/home/home.component';
import { SigninComponent } from './pages/signin/signin.component';
// Add other non-standalone components as needed

// Standalone components
import { AppComponent } from './app.component';
import { CoursePaymentsComponent } from './pages/course-payments/course-payments.component';
import { BrowserModule } from '@angular/platform-browser';
import { CommonService } from './services/common.service';
import { OrderCollegeComponent } from './ordercollege/order-college.component';
import { ForeignCollegeVideosComponent } from './foreignVideos/foreign-college-videos.component';
import { ForeignOrderCollegeComponent } from './foreignOrder/foreign-order-college.component';
// Add other standalone components as needed

@NgModule({
  declarations: [
    // HomeComponent,
    // SigninComponent,
    // other non-standalone components
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    NgbModule,
    CommonModule,
    NgxSpinnerModule,
    AccordionModule.forRoot(),
    ToastrModule.forRoot(),

    // Standalone components
    AppComponent,
    ForeignCollegeVideosComponent,
    ForeignOrderCollegeComponent,
    CoursePaymentsComponent,
    OrderCollegeComponent,
    // other standalone components
  ],
  providers: [GlobalService, AuthService, AuthGuard, UserGuard, CommonService],
  bootstrap: [AppComponent],
})
export class AppModule {}
